import { Component, OnInit, ViewChild, Output, Input, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UsersRest } from '../structure-users.rest';
import { ModalComponent } from '../../../core/shared/modal/modal.component';
import { StructureUserRole, StructureUser } from '../structure-users.model';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';

@Component({
  selector: 'smp-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit, HasPermissions {
  permissions: Permissions;
  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }
  private isEditable: boolean;
  private editMode: boolean = false;
  private isPasswordToChange: boolean = false;
  private roles: StructureUserRole[];
  private superiors: StructureUser[];

  public user: StructureUser = new StructureUser();
  private isPasswordDifferent: boolean = false;
  private hide: boolean = true;
  private hideOldPass: boolean;
  private hideRepeated: boolean = true;

  @ViewChild(ModalComponent) private modal: ModalComponent;
  @ViewChild('userForm') userForm: NgForm;
  @Output() onSuccess = new EventEmitter();
  @Input() title: string;
  @Input() selectedRoleId;

  constructor(
    private rest: UsersRest,
    private permissionService: PermissionsService
  ) { }

  ngOnInit() {
    this.setPermissions("User")
    this.rest.getUserRoles().subscribe(roles => {
      this.roles = roles;
    });
    this.rest.getAllUsers().subscribe(users => {
      this.superiors = users;
    });
  }

  public openForAdding() {
    this.editMode = false;
    this.isPasswordToChange = false;
    this.isEditable = this.permissions.canAdd;    
    this.modal.openWithCustomSize({ width: '50vh' });
  }

  public openForEdit(user: StructureUser) {
    this.editMode = true;
    this.user = user;
    let superior = this.superiors.find(s => `${s.lastName} ${s.firstName}` === this.user.superior); //TODO pociągnąć id przy pobieraniu użytkowników na grid ??
    if (superior != null) {
      this.user.superiorId = superior.id;
    }
    this.user.roleId = this.selectedRoleId;
    this.isPasswordToChange = false;
    this.isEditable = this.permissions.canEdit;
    this.modal.open();
  }

  public openForPassword() {
    this.editMode = false;
    this.isPasswordToChange = true;
    this.isEditable = this.permissions.canEdit;
    this.modal.open();
  }

  public setError(controlName: string) {
    const control = this.userForm.controls[controlName];
    return { 'has-error': control.dirty && !control.valid };
  }

  public getDisabledStatus() {
    if (!this.userForm)
      return;
    if (this.editMode) {
      return !this.isEditable || !this.userForm.valid;
    } else {
      return !this.isEditable || !this.userForm.valid || !this.userForm.dirty;
    }
  }

  public closeModal() {
    this.modal.close();
  }

  public saveUser() {
    if (this.editMode === false && this.user.password !== this.user.repeatedPassword) {
      this.isPasswordDifferent = true;
      return;
    }
    this.isPasswordDifferent = false;

    const action = this.editMode ? this.rest.editUser : this.rest.addUser;
    action.call(this.rest, this.user).subscribe(() => {
      this.modal.close();
      this.onSuccess.emit({});
    });
  }


}
